import { compareSessions, type Session } from './protocol.ts';

export { compareSessions };

/** Insert or replace a chat, then restore home-screen order. */
export function upsertSession(list: readonly Session[], session: Session): Session[] {
  const known = list.some((s) => s.id === session.id);
  const next = known
    ? list.map((s) => (s.id === session.id ? session : s))
    : [...list, session];
  return next.slice().sort(compareSessions);
}

export function moveIndex<T>(list: readonly T[], from: number, to: number): T[] {
  if (from === to || from < 0 || to < 0 || from >= list.length || to >= list.length) {
    return list.slice();
  }
  const next = list.slice();
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item!);
  return next;
}
